import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";

const domNode = document.getElementById("root");
if (!domNode) {
    throw new Error("Dom node not found");
}
const root = createRoot(domNode);

function renderApp() {
    root.render(<App />);
}

if ("hot" in module) {
    (
        module as {
            hot: {
                accept: (arg1: string, arg2: () => void) => void;
            };
        }
    ).hot.accept("./App.tsx", () => renderApp());
}
renderApp();
